import { digestList } from '@/mocks/homeData';

export default function Digest() {
  return (
    <section id="digest" className="w-full bg-background-100">
      <div className="mx-auto max-w-7xl px-4 py-10 md:px-6 md:py-14">
        <div className="mb-6 max-w-2xl">
          <p className="text-xs font-semibold tracking-[0.2em] text-accent-600">DIGEST · 扒哥黑料整全整理</p>
          <h3 className="mt-1 font-heading text-xl font-black text-foreground-950 md:text-2xl">
            把散线捋成一张图：扒哥黑料汇总复盘
          </h3>
          <p className="mt-2 text-sm leading-relaxed text-foreground-600">
            追热点最容易断线。这里把同一个人、同一件事的扒哥黑料汇总成完整链条，标记每个关键节点与留痕出处。
          </p>
        </div>

        <div className="divide-y divide-background-200 overflow-hidden rounded-lg border border-background-200 bg-background-100">
          {digestList.map((d, idx) => (
            <article
              key={d.id}
              className="group flex flex-col gap-5 p-5 md:flex-row md:gap-7 md:p-6 lg:items-start"
            >
              {/* 编号 */}
              <div className="flex items-center gap-4 md:w-40 md:shrink-0 md:flex-col md:items-start">
                <span className="font-heading text-5xl font-black leading-none text-accent-400">
                  {String(idx + 1).padStart(2, '0')}
                </span>
                <div className="flex flex-col gap-1.5 md:mt-2">
                  <span className="w-fit whitespace-nowrap rounded-full bg-accent-100 px-2 py-0.5 text-[11px] font-semibold text-accent-800">
                    {d.no} · {d.tag}
                  </span>
                  <span className="text-xs font-medium text-foreground-500">{d.subject}</span>
                </div>
              </div>

              {/* 内容 */}
              <div className="min-w-0 flex-1">
                <h4 className="font-heading text-lg font-bold leading-snug text-foreground-950 group-hover:text-primary-700 md:text-xl">
                  <a href="#guide">{d.headline}</a>
                </h4>
                <ul className="mt-3 space-y-2">
                  {d.points.map((p, i) => (
                    <li key={i} className="flex items-start gap-2.5 text-sm leading-relaxed text-foreground-700">
                      <span className="mt-0.5 flex h-4 w-4 shrink-0 items-center justify-center rounded-full bg-primary-500 text-background-50">
                        <i className="ri-check-line text-[10px]" aria-hidden="true"></i>
                      </span>
                      {p}
                    </li>
                  ))}
                </ul>
              </div>

              {/* 操作 */}
              <div className="flex items-center gap-3 md:w-40 md:shrink-0 md:flex-col md:items-end md:justify-between">
                <span className="inline-flex items-center gap-1 text-xs text-foreground-500 md:order-2">
                  <i className="ri-refresh-line" aria-hidden="true"></i>
                  {d.updated}
                </span>
                <a
                  href="#guide"
                  className="inline-flex items-center gap-1 whitespace-nowrap rounded-md bg-primary-500 px-3.5 py-2 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-600 md:order-1"
                >
                  查看整档
                  <i className="ri-arrow-right-line text-sm" aria-hidden="true"></i>
                </a>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}